import { createContext, useContext } from 'react';

export const PortalAuthContext = createContext(null);

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be used within PortalAuthProvider');
  return ctx;
}
